import React from 'react';
import { KPICard } from './KPICard';
import './SessionMetrics.css';

interface SessionMetricsProps {
  data: {
    total_sessions: number;
    avg_session_duration_minutes: number;
    avg_actions_per_session: number;
    avg_sessions_per_user: number;
    total_users: number;
  };
  loading?: boolean;
}

export const SessionMetrics: React.FC<SessionMetricsProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="session-metrics">
        <KPICard title="Total Sessions" value="0" loading={true} />
        <KPICard title="Avg Duration" value="0" loading={true} />
        <KPICard title="Actions/Session" value="0" loading={true} />
        <KPICard title="Sessions/User" value="0" loading={true} />
      </div>
    );
  }

  if (!data) {
    return <div className="session-metrics">No session data available</div>;
  }

  return (
    <div className="session-metrics">
      <KPICard
        title="Total Sessions"
        value={data.total_sessions.toLocaleString()}
        subtitle={`From ${data.total_users.toLocaleString()} users`}
        icon="🔄"
      />
      <KPICard
        title="Avg Duration"
        value={`${data.avg_session_duration_minutes.toFixed(1)} min`}
        subtitle="Per session"
        icon="⏱️"
      />
      <KPICard
        title="Actions Per Session"
        value={data.avg_actions_per_session.toFixed(1)}
        subtitle="Average interactions"
        icon="📊"
      />
      <KPICard
        title="Sessions Per User"
        value={data.avg_sessions_per_user.toFixed(1)}
        subtitle="User engagement"
        icon="👤"
      />
    </div>
  );
};

export default SessionMetrics;
